import BaseInput from "./BaseInput";
import TextInput from "./variants/TextInput";
import IntegerInput from "./variants/IntegerInput";
import FullNameInput from "./variants/FullNameInput";
import PhoneInput from "./variants/PhoneInput";
import DateInput from "./variants/DateInput";
import DateTimeInput from "./variants/DateTimeInput";
import CPFInput from "./variants/CPFInput";
import MoneyInput from "./variants/MoneyInput";
import AutoCompleteInput from "./variants/AutoCompleteInput";
import SelectInput from "./variants/SelectInput";
import SelectOptionsInput from "./variants/SelectOptionsInput";
import CNPJInput from "./variants/CNPJInput";
import EmailInput from "./variants/EmailInput";
import SwitchInput from "./variants/SwitchInput";
import ChoicesInput from "./variants/ChoicesInput";

// Create the compound component
const Input = Object.assign(BaseInput, {
    Text: TextInput,
    Integer: IntegerInput,
    FullName: FullNameInput,
    Phone: PhoneInput,
    Date: DateInput,
    DateTime: DateTimeInput,
    CPF: CPFInput,
    Money: MoneyInput,
    AutoComplete: AutoCompleteInput,
    Select: SelectInput,
    SelectOptions: SelectOptionsInput,
    CNPJ: CNPJInput,
    Email: EmailInput,
    Switch: SwitchInput,
    Choices: ChoicesInput
});

export default Input;
